var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[(_vm.isFirstCreate)?_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.value.title))]):_vm._e(),_c('div',{ref:"echart",staticClass:"echart"})])
}
var staticRenderFns = []

export { render, staticRenderFns }